import { z } from "zod";

/**
 * Domain типы для валидации форм
 * Используются в boundary слое вместо прямых импортов из infrastructure
 */

export namespace ValidationDto {
  export const phone = () =>
    z
      .string()
      .regex(
        /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/,
        "Введите корректный номер телефона"
      );

  export const otp = () =>
    z
      .string({ required_error: "Введите значение" })
      .transform((val) => val.replace(/\s/g, "")) // Удаляем все пробелы (для автовставки из SMS)
      .pipe(
        z
          .string()
          .regex(/^\d{6}$/, "Код должен содержать 6 цифр")
      );

  export const required = () =>
    z
      .string({
        required_error: "Обязательное поле"
      })
      .trim()
      .min(1, "Обязательное поле");
}

